import {
  type CreateValues,
  type FindAllOptions,
  type PracticeConfigEhrInstance,
  type UpdateValues,
} from '../../models/orchestrator/practiceConfig/ehrInstance.js';
import {
  type PaginatedQueryOptions,
  type PaginationResponse,
} from '../../models/pagination/index.js';
import OrchestratorAPI from '../common.js';

export default class API extends OrchestratorAPI {
  public readonly API_PATH = '/practice-config-ehr-instances';
  public readonly baseEndpoint = `${this.BASE_URL}${this.API_PATH}`;

  async findAll(options: FindAllOptions = {}): Promise<PracticeConfigEhrInstance[]> {
    const url = this.constructPath('/', options);
    const { practiceConfigEhrInstances } = await this.common.getJSON(url);
    return practiceConfigEhrInstances.map(this.deserialize);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<PracticeConfigEhrInstance>> {
    const url = this.constructPath('/', options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<PracticeConfigEhrInstance> {
    const url = this.constructPath(`/${id}`);
    const { practiceConfigEhrInstance } = await this.common.getJSON(url);
    return this.deserialize(practiceConfigEhrInstance);
  }

  async create(values: CreateValues): Promise<PracticeConfigEhrInstance> {
    const url = this.constructPath('/');
    const { practiceConfigEhrInstance } = await this.common.postJSON(url, values);
    return this.deserialize(practiceConfigEhrInstance);
  }

  async remove(id: string): Promise<void> {
    const url = this.constructPath(`/${id}`);
    return await this.common.deleteJSON(url);
  }

  async update(id: string, values: UpdateValues): Promise<PracticeConfigEhrInstance> {
    const url = this.constructPath(`/${id}`);
    const { practiceConfigEhrInstance } = await this.common.patchJSON(url, values);
    return this.deserialize(practiceConfigEhrInstance);
  }
}
